// Dependencies
import { useState, useEffect, useRef, useCallback, useContext } from "react";
import { Portal } from "react-portal";
import classNames from "classnames";
import { CSSTransition } from "react-transition-group";
import { enableBodyScroll, disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

// Hooks
import { useDebug } from "../hooks";

// Types
import { Types, Components } from '../types';

// Utils
import {  } from '../utils/config'
import {  } from '../utils/helpers'

const Overlay = ({isVisible, height, disableScrollWhenVisible, isPortaled = false, onClick: handleClick = undefined, className = []}: Components.Overlay) => {

    // useEffect(() => {

    //     if ( disableScrollWhenVisible) {
            
    //         if ( isVisible ) {
    //             disableBodyScroll(document.body, {
    //                 reserveScrollBarGap: false,
    //             });  
    //         } else {
    
    //             setTimeout(() => {
    //                 clearAllBodyScrollLocks();    // NOTE:    Adding timeout for re-enabling scrolling to show the scrollbar right before the minicart slides away
    //             }, 500 - 75); // TODO:   Animation/transition timeout should be defined as constant to keep things consitent (calciulating with 75ms offset) 
    
    //         }

    //         return () => clearAllBodyScrollLocks();

    //     } 
        
    // }, [isVisible, disableScrollWhenVisible]);

    if ( isPortaled ) {

        return (
            <CSSTransition mountOnEnter unmountOnExit in={isVisible} timeout={500}>
                <Portal>
                    <div style={{height: `${height}px`}} onClick={(e) => handleClick && handleClick(e)} className={classNames('wooptima-overlay', ...className)}></div>
                </Portal>
            </CSSTransition>
        ) 
    }

    return (
        <CSSTransition mountOnEnter unmountOnExit in={isVisible} timeout={500}>
            <div  style={{height: `${height}px`}} onClick={(e) => handleClick && handleClick(e)} className={classNames('wooptima-overlay', ...className)}></div>
        </CSSTransition>
    ) 
}

export default Overlay; 